module.exports = __webpack_public_path__ + "img/20240715_Cora-Kennedy_FSGP-2024_02989.d98068ce.jpg";